// extracted by mini-css-extract-plugin
module.exports = {"banner":"Registor_banner__2AhK3","itemsOnBanner":"Registor_itemsOnBanner__1Ko7-","countDown":"Registor_countDown__o2N7f","registor":"Registor_registor__2-_XL"};